import { useState, useEffect } from 'react';
import useDataBean from '../../../core/services/dataBean/useDataBean';
import { _LabourType, _RemoteAbstractAction } from '../../../core/services/dataBean/EntityCatalog';
import { BasicTable, MASK_NUMBER } from '../../theme/Component/BasicTable';
import { Modal } from '../../theme/Component/Modal';
import useModal, { MODAL_LG, MODAL_md, MODAL_SM } from '../../theme/Component/hooks/useModal';
import { BasicButton } from '../../theme/Component/BasicButton';
import usePaginator from '../../theme/Component/usePaginator';
import { _ProjectGet } from '../../../core/services/dataBean/EntityCatalogVdos';
import { AccountEditor } from '../../editor/AccountEditor';
import { InputDate } from '../../theme/Input/InputDate';
import { keepPreviousData, useQuery } from '@tanstack/react-query';

interface Props {
    idSelector: number;
    onChange: any;
    label?: string;
    returnType?: "ID" | "Object";
    render?: string;
}

export const ProjectSelectEditor = ({ idSelector, onChange, label, returnType = "ID", render }: Props) => {
    // Draft states for inputs
    const [regexStr, setregexStr] = useState<string>('')
    const [project, setproject] = useState<any>(null)
    const [Account, setAccount] = useState<any>(null)
    const [state, setstate] = useState<any>(null)
    const [date, setdate] = useState<any>(null)

    // Active params that trigger the query
    const [activeParams, setActiveParams] = useState({
        project: null,
        Account: null,
        state: null,
        regexStr: '',
        date: null
    });

    const { instance } = useDataBean(_ProjectGet)
    const [id, setID] = useState(null);
    const paginador = usePaginator();
    // const [records, setRecords] = useState<number>(15); // Unused
    const modal = useModal("Tabla de Proyectos", MODAL_LG);

    useEffect(() => {
        setID(idSelector)
    }, [idSelector])

    const fetchProjects = async () => {
        return instance.getProjectCatalog(
            activeParams.project,
            activeParams.Account,
            activeParams.state,
            activeParams.regexStr,
            activeParams.date,
            paginador.page,
            15
        );
    }

    const { data: resp, isFetching } = useQuery({
        queryKey: ['ProjectSelectEditor', activeParams, paginador.page],
        queryFn: fetchProjects,
        placeholderData: keepPreviousData,
        staleTime: Infinity,
        enabled: modal.modal.view // Only fetch if modal is open (optional optimization, but good for "select" type components)
    });

    useEffect(() => {
        if (resp) {
            paginador.setPages(resp.NumberOfPages);
            paginador.setRecords(resp.NumberOfPages * 15);
            paginador.setRegiPerPage(15);
        }
    }, [resp]);

    const setValue = (e: string) => {
        const selectedId = parseInt(e);
        setID(selectedId);
        if (onChange) {
            const selectedItem = resp?.List?.find(
                (item: any) => item?.DataBeanProperties?.IDProject == e
            );
            if (selectedItem) {
                onChange(returnType === "Object" ? selectedItem?.DataBeanProperties : selectedId);
            } else {
                onChange(returnType === "Object" ? {} : null);
            }
        }
    };

    const handleSearch = () => {
        setActiveParams({
            project,
            Account,
            state,
            regexStr,
            date
        });
        paginador.setPage(1); // Reset to page 1 on new search
    }

    const head = [
        { title: 'ID', property: 'IDProject', visible: true, mask: MASK_NUMBER },
        { title: 'Nombre', property: 'Name', visible: true },
        { title: 'Codigo', property: 'Code', visible: true },
        { title: 'Objeto', property: 'ObjectText', visible: true },
        { title: 'Fecha Inicio', property: 'InitDate', visible: true },
        { title: 'Fecha Terminación', property: 'UptoDate', visible: true },
    ]
    const abrirModal = () => {
        modal.open();
    }


    return (
        <>
            <label>{label ?? "Proyecto"}</label>
            <span className='form-control cursor ifmodal' onClick={abrirModal}>{render ?? ''}</span>
            <Modal modal={modal.modal} updateModal={modal.setModal}>
                <div className="row">
                    <div className="col-md-6">
                        <label>Buscar ID </label>
                        <input type="text" name="project" className="form-control" value={project || ''} onChange={(e) => { setproject(parseInt(e.target.value) || null) }} />
                    </div>
                    <div className="col-md-6">
                        <AccountEditor idAccount={Account} onChange={(e) => { setAccount(e.IDAccount) }} label="Tercero" />
                    </div>
                    <div className="col-md-6">
                        <label>Estado </label>
                        <input type="text" name="project" className="form-control" value={state || ''} onChange={(e) => { setstate(parseInt(e.target.value) || null) }} />
                    </div>
                    <div className="col-md-6">
                        <label>Búsqueda por Texto</label>
                        <input type="text" name="regexStr" className="form-control" value={regexStr} onChange={(e) => { setregexStr(e.target.value) }} />
                    </div>
                    <div className="col-md-6">
                        <InputDate name="date" label="Fecha de Corte" value={date} setDate={(e: any) => { setdate(e) }} />
                    </div>
                    <div className="col-md-6 mt-4">
                        <BasicButton icon="ri-add-circle-line" clase="primary" eventClick={handleSearch}>
                            Buscar
                        </BasicButton>
                    </div>
                    <div className="col-md-12">
                        <BasicTable
                            head={head}
                            body={resp?.List || []}
                            rowSet={(e) => { setValue(e.IDProject); modal.close(); }}
                            pageTop={paginador.page} next={paginador.next} back={paginador.back} records={paginador} customRows={15}
                        />
                    </div>
                </div>
            </Modal >
        </>
    )
}